import React, { useEffect } from "react";
import { Stack, Typography, Box, Button } from "@mui/material";
import IosSwitch from "../../components/IOSSwitch";
import SikiInput from "../SikiInput";
import { kFormatter } from "../../constants/function";
import { useTranslation } from "react-i18next";
import notifier from "../../components/Notifier";
import { useTheme, lighten, darken } from "@mui/material/styles";

export default function SetSubscription(props) {
  const { t } = useTranslation("common");
  const theme = useTheme();
  const primaryColor = theme.palette.primary.main;
  const primaryContrast = theme.palette.primary.contrastText || "#000000";
  const textPrimary = theme.palette.text.primary || "#FFFFFF";
  const textSecondary = theme.palette.text.secondary || "#B0B0B0";
  const paperColor = theme.palette.background.paper || "transparent";
  const hoverPrimary =
    theme.palette.mode === "dark"
      ? lighten(primaryColor, 0.1)
      : darken(primaryColor, 0.1);
  const [checked, setChecked] = React.useState(false);
  const [fee, setFee] = React.useState("");
  const [isFeeSet, setIsFeeSet] = React.useState(false);

  const handleChange = (value) => {
    console.log(value);
    setChecked(value);
    props.checked(value, fee);
  };

  const handleSetFee = () => {
    if (fee) {
      if (fee == 0) {
        notifier.error(t("notifier.error.toast16"))
      } else {
        props.checked(checked, fee);
        handleFeechange(true);
      }
    }
  };

  const handleFeechange = (b) => {
    setIsFeeSet(b);
    props.changeFee(b);
  };

  useEffect(() => {
    if (
      props["subscription"] &&
      props["subscription"]["subscriptionStatus"] === "enabled"
    ) {
      setIsFeeSet(true);
      setChecked(true);
      setFee(props["subscription"]["subscriptionFee"]);
    }
  }, []);

  return (
    <Stack
      sx={{
        width: "100%",
        borderRadius: "25px",
        minHeight: "80px",
        background: checked && !isFeeSet ? paperColor : "transparent",
      }}
    >
      <Stack direction="column" padding="6px">
        <Stack
          direction="row"
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            width: "auto",
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              color: textPrimary,
              fontSize: 17,
              marginRight: "auto",
            }}
          >
            {t("myProfile.subscription.header")}
          </Typography>
          <IosSwitch checked={checked} handleChange={handleChange} />
        </Stack>
        {checked && isFeeSet ? (
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Stack direction="column" alignItems="start">
              <Typography
                className="fs-14"
                sx={{ color: textSecondary }}
              >
                {t("myProfile.subscription.subHeader")}
              </Typography>
              <Stack direction="row" alignItems="center" spacing={1}>
                <Typography
                  className="fs-14"
                  sx={{
                    color: textPrimary,
                    textDecoration: "none !important"
                  }}
                >
                  {props["subscription"]
                    ? props["subscription"]["subscriptionFee"]
                    : 0}{" "}
                  {t("myProfile.subscription.tokens")}{" "}
                </Typography>
                <Typography
                  sx={{ 
                    color: primaryColor,
                    textDecoration: 'underline',
                    cursor: 'pointer',
                    '&:hover': {
                      color: hoverPrimary
                    }
                  }}
                  className="fs-14"
                  onClick={() => handleFeechange(false)}
                >
                  {t("myProfile.subscription.button")}
                </Typography>
              </Stack>
            </Stack>
            <Stack direction="column" alignItems="end">
              <Typography
                className="fs-14"
                sx={{ color: textSecondary }}
              >
                {t("myProfile.subscription.subscribers")}
              </Typography>
              <Typography
                className="fs-14"
                sx={{ color: textPrimary }}
              >
                {props["subscription"] && props["subscription"]["subscribers"]
                  ? kFormatter(props["subscription"]["subscribers"])
                  : ""}
              </Typography>
            </Stack>
          </Stack>
        ) : null}
      </Stack>
      {checked && !isFeeSet ? (
        <Box sx={{ padding: "10px 21px" }}>
          <Stack>
            <SikiInput
              type="number"
              label={t("myProfile.subscription.label")}
              placeholder={t("myProfile.subscription.placeholder")}
              value={fee}
              onChange={(e) => {
                if (e === 0) {
                  notifier.error(t("notifier.error.toast16"))
                } else setFee(e)
              }}
            />
            <Typography variant="body2" mt={1} className="fade-text">
              {t("myProfile.subscription.text1")}
            </Typography>
            <Typography variant="body2" mt={1} className="fade-text">
              {t("myProfile.subscription.text2")}
            </Typography>
            <Button
              onClick={handleSetFee}
              variant="contained"
              sx={{
                marginTop: "1rem",
                backgroundColor: primaryColor,
                color: primaryContrast,
                '&:hover': {
                  backgroundColor: hoverPrimary
                },
                '&:disabled': {
                  opacity: 0.5,
                  backgroundColor: primaryColor,
                  color: primaryContrast
                }
              }}
              disabled={fee === "" || fee < 0}
            >
              {t("myProfile.subscription.button1")}
            </Button>
          </Stack>
        </Box>
      ) : null}
    </Stack>
  );
}
